import { Box, Breadcrumbs, Button, Link, Skeleton, Typography } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
//eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
//@ts-ignore
import FadeIn from 'react-fade-in';
import { useAppSelector } from "../../../redux/store";
import { Suspense } from "react";

const InformePageLayout = () => {
    const theme = useAppSelector(state => state.theme)
    const location = useLocation()
    const n = useNavigate()
    const irAInicio = () => {
        n('/');
    };
    const informe = location.pathname.split('/')[2];
    let miInforme = informe.replaceAll('-', ' ').replaceAll('capital', '').replaceAll('provincia', '')
    miInforme = miInforme.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));


return (
  <Box sx={{ width: '100%' }}>
    <div
      role="presentation"
      style={{
        marginTop: '1rem',
        padding: '1rem 0rem 0rem 4rem',
      }}
    >
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" onClick={() => n('/')}>
          Inicio
        </Link>
        <Link underline="hover" color="inherit" onClick={() => n('/')}>
          Informes
        </Link>
        <Typography color="text.primary">{miInforme}</Typography>
      </Breadcrumbs>
    </div>

    <Button
      type="submit"
      variant="contained"
      onClick={irAInicio}
      sx={{
        display: 'initial',
        margin: '0 auto',
        marginTop: '1rem',
        marginBottom: '1rem',
        marginLeft: '4rem'
      }}
    >
      Volver al inicio
    </Button>

    <FadeIn delay={1}
        transitionDuration={300}
    >

        <Suspense fallback={
            <Box aria-label='loading-informe' sx={{
                boxShadow: '1px 2px 20px 0px #00000026',
                borderTopStyle: 'solid',

                maxWidth: '40rem',
                margin: '0 auto',
                marginTop: '3rem',
                borderRadius: '5px',
                borderTopWidth: '3px',
            }}>
                <Skeleton variant="rectangular" width={'100%'} height={700} sx={{ mb: '3px' }} />


            </Box>
        }>

            <Box sx={{
                maxWidth: '40rem',
                width: '100%',
                margin: '0 auto',
                display: 'flex',
                justifyContent: 'center',
                padding: '2rem',
                backgroundColor: theme.darkTheme ? '#1e1e1e' : 'white',
                //marginTop: '-14rem',
                marginTop: '3rem',
                borderRadius: '5px',
                borderTopWidth: '3px',
                borderTopStyle: 'solid',
                marginBottom: '2rem',
                boxShadow: '1px 2px 20px 0px #00000026',
            }}>
                <Outlet />

            </Box>
        </Suspense>

    </FadeIn>


</Box >


);
}

export default InformePageLayout;